import styled from 'styled-components';
import { Input } from '@carvana/showroom-forms';

export const TabWrapper = styled.section`
  flex: 1;
  display: flex;
  flex-flow: column;
  box-shadow: 0 2px 3px rgba(25, 41, 61, 0.13);
  background: ${(props: any) => props.theme.carvana.white.primary};

  @media only screen and (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    margin: 20px 30px 45px 20px;
  }

  @media only screen and (min-width: ${(props: any) => props.theme.breakpoints.values.md}px) {
    margin: 34px;
  }
`;

export const TabContent = styled.div`
  display: flex;
  flex-flow: column;
  padding: 0px 30px 30px;

  @media only screen and (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    padding: 0 40px 40px;
  }

  @media only screen and (min-width: ${(props: any) => props.theme.breakpoints.values.md}px) {
    max-width: 564px;
  }
`;

export const FormInput = styled(Input)`
  width: 480px;
`;
